// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (froggy.require) {
	froggy.require("file_uploader.bundle.js");
} else {
	froggy.ready(function () {
		froggy.require("file_uploader.bundle.js");
	});
}
